interface DashboardkeysType {
  [key: string]: string;
  home: string;
  revenue: string;
}

export const dashboards: DashboardkeysType = {
  home: "Home Dashboard",
  revenue: "Revenue Dashboard",
  cogs: "COGS Dashboard",
  labour: "Labour Dashboard",
  notification: "Notification Center",
  historical: "Historical Reports",
  check: "Check Information",
};

export const getPropertyCustomExtraPath = (filters: FilterType) => {
  let path = "";
  const { property, store, rvc, date } = filters || {};

  if (property) {
    path += `?property=${property?.toString().trim()}`;
  }

  if (store) {
    path += `&store=${store?.toString().trim()}`;
  }

  if (rvc) {
    path += `&rvc=${rvc?.toString().trim()}`;
  }

  if (date) {
    path += `&date=${date?.toString().trim()}`;
  }

  return path;
};
